/**
 * The component library's own words (decision 34: every string through i18n). A component that has words of its own
 * (Close, Cancel, Copied, a field's "Show password") reads them from the catalog's `ui.*` keys through `uiText()`.
 * The app gives its translator once at its start (`setUiText`); until then, and in the gallery and in screen tests
 * that mount a piece alone, the English catalog speaks, the only language there is. A page speaks one language, so
 * the words are the page's, not a context's. Words a screen passes in (a dialog's title, a button's label) never come
 * through here.
 */
import { createSignal } from 'solid-js';
import { EN } from '../i18n/en.ts';
import type { Messages } from '../i18n/en.ts';
import { createTranslator } from '../i18n/i18n.ts';
import type { Translate } from '../i18n/i18n.ts';

const [words, setWords] = createSignal<Translate<Messages>>(createTranslator(EN, 'en'));

/** The page's translator for the library's words. Read it where the words show, so a change of language follows. */
export function uiText(): Translate<Messages> {
  return words();
}

/** Gives the library the app's translator (at the app's start). */
export function setUiText(translate: Translate<Messages>): void {
  setWords(() => translate);
}
